export function getBADemoData(firstName) {
  const data = [
    {
      name: { first: 'Lisa', last: 'Hendrix', middle: null, goesBy: null, prefix: null, suffix: null },
      selfAssessmentScore: { aSigma: 0.82, bSigma: 0.43, cSigma: -0.8, dSigma: -0.45, eSigma: -0.01 },
      referencePattern: {
        patternNumber: 26,
        referencePatternName: 'Captain',
        singularName: null,
        pluralName: null,
        description: 'A Captain is a problem solver who likes change and innovation while controlling the big picture.',
        descriptionBolded:
          'A <strong>Captain</strong> is a problem solver who likes change and innovation while controlling the big picture.',
        moreInfoLink: null,
      },
      preferredWorkStyles: [
        '<li>Proactivity, assertiveness, and sense of urgency in driving to reach personal goals. Openly challenges the world.</li><li>Independent in putting forth their own ideas, which are often innovative and, if implemented, cause change. Resourcefully works through or around anything blocking completion of what they want to accomplish; aggressive when challenged.</li><li>Impatient for results, puts pressure on themself and others for rapid implementation, and is far less productive when doing routine work.</li>',
        '<li>Risk-taking, daring, and focus on future goals; this individual is more concerned with where they’re going than either how they’ll get there, or where they’ve been. Adaptable, operates flexibly.</li><li>Makes decisions and takes action, even with little proof confirming their decision. Confident in their own ideas and unimpressed with tradition.</li><li>Flexible approach to “the book” often bends the rules and does things their own way. An innovative, "outside the box" thinker who is undaunted by failure.</li>',
        '<li>Proactively connects quickly to others; open and sharing. Builds and leverages relationships to get work done.</li><li>Comfortably fluent and fast talk, in volume. Enthusiastically persuades and motivates others by considering their point of view and adjusting delivery.</li><li>Collaborative; usually works with and through others. Intuitive understanding of team cohesion, dynamics, and interpersonal relations.</li>',
      ],
      personNeedsListContent: [
        {
          needsListContentTitle: 'Let me drive',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Independence| Control of own activities| To be challenged| Understanding of the big picture| Autonomy in problem solving| Individual recognition| Opportunities to compete',
        },
        {
          needsListContentTitle: 'Give me variety',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Variety| Opportunities to work at a faster than average pace| Mobility| Freedom from repetition| Opportunities to handle multiple priorities| Freedom from routine| Change',
        },
        {
          needsListContentTitle: 'Give me flexibility',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Freedom from rigid structure| Freedom of expression| Opportunities to delegate details| Freedom from rules and controls| Flexibility| Informality| Opportunities to be spontaneous',
        },
        {
          needsListContentTitle: 'Let me talk it out',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Opportunities to interact| Social acceptance| Opportunities to influence| Public recognition| Connection with others| Visible signs of accomplishments| Opportunities to work with others',
        },
      ],
      strengths:
        'Seeks to lead and have an impact| People-oriented, sociable| Able to deal with time pressure and change',
      cautionAreas: 'Can seem authoritative | May appear to be brusk | Struggles to adhere to structure or direction',
      factors: [
        {
          letter: 'A',
          sigmaZone: 1,
          absoluteSigmaValue: 0.82,
          motivatingNeedTraits:
            'Independence| Control of own activities| To be challenged| Understanding of the big picture| Autonomy in problem solving| Individual recognition| Opportunities to compete',
          behaviorTraits:
            'Independent| Assertive| Self-confident| Venturesome| Competitive| Comfortable with conflict| Autonomous ',
          sigmaRangeTraits: 'Moderately Assertive| Independent| Determined| Autonomous',
          factorName: 'Dominance',
          primaryTrait: 'Assertive',
          leftFactorTrait: 'Collaborative',
          rightFactorTrait: 'Moderately Independent',
        },
        {
          letter: 'B',
          sigmaZone: 1,
          absoluteSigmaValue: 0.43,
          motivatingNeedTraits:
            'Opportunities to interact| Social acceptance| Opportunities to influence| Public recognition| Connection with others| Visible signs of accomplishments| Opportunities to work with others',
          behaviorTraits: 'Outgoing| People oriented| Persuasive| Stimulating| Enthusiastic| Empathetic| Sociable',
          sigmaRangeTraits: 'Moderately Outgoing| Sociable| Talkative| Open',
          factorName: 'Extraversion',
          primaryTrait: 'Outgoing',
          leftFactorTrait: 'Reserved',
          rightFactorTrait: 'Moderately Sociable',
        },
        {
          letter: 'C',
          sigmaZone: -1,
          absoluteSigmaValue: 0.8,
          motivatingNeedTraits:
            'Variety| Opportunities to work at a faster than average pace| Mobility| Freedom from repetition| Opportunities to handle multiple priorities| Freedom from routine| Change',
          behaviorTraits: 'Intense| Restless| Driving| Impatient| Rushed| Fast-paced',
          sigmaRangeTraits: 'Moderately Impatient| Hurried| Brisk| Quick',
          factorName: 'Patience',
          primaryTrait: 'Impatient',
          leftFactorTrait: 'Moderately Driving',
          rightFactorTrait: 'Steady',
        },
        {
          letter: 'D',
          sigmaZone: -1,
          absoluteSigmaValue: 0.45,
          motivatingNeedTraits:
            'Freedom from rigid structure| Freedom of expression| Opportunities to delegate details| Freedom from rules and controls| Flexibility| Informality| Opportunities to be spontaneous',
          behaviorTraits: 'Informal| Tolerant of uncertainty| Flexible| Spontaneous| Non-conforming| Casual| Adaptable',
          sigmaRangeTraits: 'Moderately Flexible| Casual| Uninhibited| Adaptable',
          factorName: 'Formality',
          primaryTrait: 'Non-conforming',
          leftFactorTrait: 'Moderately Flexible',
          rightFactorTrait: 'Precise',
        },
      ],
      factorDescriptions: [
        {
          factorLetter: 'A',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            "They have many ideas and opinions and they're keen to share them. They're hands-on and focused on producing results. They value independence and autonomy.",
        },
        {
          factorLetter: 'B',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            "This person is energized by interacting with others. They're approachable, friendly, and pleasant around others. you can count on them to share and build enthusiasm—a consummate team-first person.",
        },
        {
          factorLetter: 'C',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They may act with a sense of urgency, wanting to get tasks done. They benefit from variety in their workload and can quickly take the reins of a project if it needs to be pushed forward to completion.',
        },
        {
          factorLetter: 'D',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They’ll generally consider the endgame—the ultimate goal or finished product—over the means of execution. They don’t adhere to a given system or process if there is a more efficient approach that still satisfies all parties and objectives.',
        },
        {
          factorLetter: 'E',
          factorDescription:
            'Shifts between objectivity and subjectivity; may favor facts or intuition based on the situation',
          factorFullDescription:
            'If someone is very close to the center (midpoint), the expression of this drive may depend on the specific context or situation.',
        },
      ],
      factorCombinations: [
        {
          traits: 'Situationally task- or people-oriented',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A equal B',
          primaryTrait: 'Task- or people-oriented',
          isAdapterPattern: null,
        },
        {
          traits:
            'Takes initiative| Competitive| Driven to get things done| Positive response to pressure| Fast-paced| Achievement-oriented| Impatient with routine',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A over C',
          primaryTrait: 'Proactive',
          isAdapterPattern: null,
        },
        {
          traits: 'Independent| Individualistic| Self-confident| Firm| Decisive| Venturesome| Resistant to authority',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A over D',
          primaryTrait: 'Comfortable with risk',
          isAdapterPattern: null,
        },
        {
          traits:
            'Fluent| Fast-talking| Lively| Enthusiastic| Optimistic style of expression| Persuasive| Motivates others| Stimulating| Positive communication',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'B over C',
          primaryTrait: 'Quick to connect',
          isAdapterPattern: null,
        },
        {
          traits:
            'Extraverted| Outgoing| Uninhibited expression of friendliness| Poised| Informal in social situations| Enthusiastic, persuasive talker| Engaging conversationalist',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'B over D',
          primaryTrait: 'Informal',
          isAdapterPattern: null,
        },
        {
          traits: 'Situationally casual or careful with rules',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'C equal D',
          primaryTrait: 'Casual or careful with rules',
          isAdapterPattern: null,
        },
      ],
      hasPendingBa: false,
      assessmentUserId: '4295f848-039a-4086-9f88-9256f05ebac7',
    },
    {
      name: { first: 'Will', last: 'Marks', middle: '', goesBy: null, prefix: null, suffix: null },
      selfAssessmentScore: { aSigma: -1.71, bSigma: -0.2, cSigma: 0.51, dSigma: 1.4, eSigma: 0.69 },
      referencePattern: {
        patternNumber: 60,
        referencePatternName: 'Guardian',
        singularName: null,
        pluralName: null,
        description: 'A Guardian is unselfish and approachable with a preference for detailed, skill-based work.',
        descriptionBolded:
          'A <strong>Guardian</strong> is unselfish and approachable with a preference for detailed, skill-based work.',
        moreInfoLink: null,
      },
      preferredWorkStyles: [
        '<li>Driven to protect the company against risk by thoroughly leveraging their background and strictly following “the book.”</li><li>Cautious; follows a well-established and proven plan to avoid making mistakes. Does the background research necessary to have proof to support decisions before action is taken.</li><li>Detail-oriented and accommodating; most comfortable working as part of a well-defined team for which they produce high-quality output and decisions.</li>',
        '<li>Unhurried and deliberate, stable and will do things using the established process; finds it difficult to change these systems. Dependable, consistent and needs familiar environments and coworkers to be most productive.</li><li>Cooperative, easy-going, and agreeable in getting along with others. A focused, uncritical listener who won’t “rock the boat.”</li><li>Methodical, steady, and even-paced; loses productivity when interrupted.</li>',
        '<li>Formal, reserved, introspective, and skeptical of new people; requires “proof” to build trust in new people.</li><li>Detail-oriented and precise; follow-through is deep and literal to ensure tasks were completed in accordance with quality standards.</li><li>Operationally, as opposed to socially, focused. Thinks, in specific terms, about what needs to be done and how to do it accurately and flawlessly; follows, in a literal way, that execution plan.</li>',
      ],
      personNeedsListContent: [
        {
          needsListContentTitle: 'Let me collaborate',
          patternInsightsNeedsContent: 'Needs lots of...',
          needsListContent:
            'Encouragement| Reassurance| Harmony| Understanding| Team recognition| Freedom from individual competition| Opportunities to collaborate',
        },
        {
          needsListContentTitle: 'Give me structure',
          patternInsightsNeedsContent: 'Needs lots of...',
          needsListContent:
            'Understanding of rules and regulations| Specific knowledge of the job| Freedom from risk of error| Time to gain expertise| Recognition for depth of knowledge| Clarity of expectations| Certainty',
        },
        {
          needsListContentTitle: 'Give me stability',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Long-term affiliation| Ability to work at a steady pace| Familiar surroundings| Stable work environment| Freedom from changing priorities| Supportive work team| Recognition for loyalty',
        },
        {
          needsListContentTitle: 'Let me think it through',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Balance of: Opportunities to interact and Opportunities to reflect | Social acceptance and Room for introspection | Opportunities to influence and Freedom from office politics',
        },
      ],
      strengths: 'Thoughtful approach when communicating| Close attention to detail| Strong discipline and execution',
      cautionAreas: 'May be sensitive to criticism | May avoid conflict | May struggle in ambiguous situations',
      factors: [
        {
          letter: 'A',
          sigmaZone: -2,
          absoluteSigmaValue: 1.71,
          motivatingNeedTraits:
            'Encouragement| Reassurance| Harmony| Understanding| Team recognition| Freedom from individual competition| Opportunities to collaborate',
          behaviorTraits:
            'Cooperative| Accepting of company policies| Accommodating| Pleasing| Harmony-seeking| Collaborative| Obliging',
          sigmaRangeTraits: 'Very Agreeable| Cooperative| Accepting| Collaborative',
          factorName: 'Dominance',
          primaryTrait: 'Agreeable',
          leftFactorTrait: 'Very Collaborative',
          rightFactorTrait: 'Independent',
        },
        {
          letter: 'B',
          sigmaZone: 0,
          absoluteSigmaValue: 0.2,
          motivatingNeedTraits:
            'Balance of: Opportunities to interact and Opportunities to reflect | Social acceptance and Room for introspection | Opportunities to influence and Freedom from office politics',
          behaviorTraits: 'Outgoing and Introspective | People oriented and Matter-of-fact | Persuasive and Analytical',
          sigmaRangeTraits: 'Sociable and Quiet | Persuasive and Sincere | Talkative and Introspective',
          factorName: 'Extraversion',
          primaryTrait: 'Situationally Outgoing and Reserved',
          leftFactorTrait: 'Situationally Reserved',
          rightFactorTrait: 'Situationally Sociable',
        },
        {
          letter: 'C',
          sigmaZone: 1,
          absoluteSigmaValue: 0.51,
          motivatingNeedTraits:
            'Long-term affiliation| Ability to work at a steady pace| Familiar surroundings| Stable work environment| Freedom from changing priorities| Supportive work team| Recognition for loyalty',
          behaviorTraits: 'Agreeable| Patient| Stable| Calm| Deliberate| Comfortable with the familiar| Steady',
          sigmaRangeTraits: 'Moderately Patient| Stable| Calm| Composed',
          factorName: 'Patience',
          primaryTrait: 'Steady',
          leftFactorTrait: 'Driving',
          rightFactorTrait: 'Moderately Steady',
        },
        {
          letter: 'D',
          sigmaZone: 2,
          absoluteSigmaValue: 1.4,
          motivatingNeedTraits:
            'Understanding of rules and regulations| Specific knowledge of the job| Freedom from risk of error| Time to gain expertise| Recognition for depth of knowledge| Clarity of expectations| Certainty',
          behaviorTraits: 'Serious| Diligent| Reserved| Thorough| Precise| Organized| Cautious',
          sigmaRangeTraits: 'Very Careful| Disciplined| Deliberate| Conventional',
          factorName: 'Formality',
          primaryTrait: 'Conforming',
          leftFactorTrait: 'Flexible',
          rightFactorTrait: 'Very Precise',
        },
      ],
      factorDescriptions: [
        {
          factorLetter: 'A',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They’re content cooperating with others or with the team needs. They’re considerate and will accommodate others’ needs and requests when possible. They thrive on a sense of community and camaraderie.',
        },
        {
          factorLetter: 'B',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'If someone is very close to the center (midpoint), the expression of this drive may depend on the specific context or situation.',
        },
        {
          factorLetter: 'C',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They take comfort in familiarity and affiliation. They’re appreciative of the care and support of their team, and they value recognition of their loyalty.',
        },
        {
          factorLetter: 'D',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They’ll avoid risks in most situations, preferring to operate within established guidelines or processes. They’re careful in their work, leaning heavily on the systems in place. They often exert tight control on shared work or decisions.',
        },
        {
          factorLetter: 'E',
          factorDescription: 'Leans toward logic; likely to weigh facts and data over opinions',
          factorFullDescription:
            "They are guided by logic. When making a decision, they're likely to weigh facts and data over opinions. They tend to be contemplative and analytical in their day-to-day work.",
        },
      ],
      factorCombinations: [
        {
          traits: 'Friendly | Quiet | Unassuming | Seeks team harmony',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'B over A',
          primaryTrait: 'People-oriented',
          isAdapterPattern: null,
        },
        {
          traits:
            'Consistent with repetitive work| Cooperative with others| Tolerant| Patient| Dependable| Steady| Easygoing',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'C over A',
          primaryTrait: 'Responsive',
          isAdapterPattern: null,
        },
        {
          traits:
            'Cooperative| Supportive| Willing and helpful| Need for rules and structure| Accurate and careful| Concerned about criticism| Conservative',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'D over A',
          primaryTrait: 'Cautious with risk',
          isAdapterPattern: null,
        },
        {
          traits:
            'Patient | Calm | Easygoing | Unhurried relationship builder | Good listener | talkative | Comfortable with others',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'C over B',
          primaryTrait: 'Takes time to connect',
          isAdapterPattern: null,
        },
        {
          traits: 'Formal | Social | Proper | Trouble delegating details| Detailed and talkative communicator',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'D over B',
          primaryTrait: 'Formal',
          isAdapterPattern: null,
        },
        {
          traits:
            'Accurate | Thorough | Methodical | Stable | Careful | Conscientious | Respects authority | Reluctant to delegate details | Detailed and talkative communicator',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'D over C',
          primaryTrait: 'Careful with rules',
          isAdapterPattern: null,
        },
      ],
      hasPendingBa: false,
      assessmentUserId: '89d0b543-5486-4d1c-9012-ac306bc26c40',
    },
    {
      name: { first: 'Chaya', last: 'Long', middle: '', goesBy: null, prefix: null, suffix: null },
      selfAssessmentScore: { aSigma: 0.15, bSigma: -0.45, cSigma: 0.15, dSigma: 0.15, eSigma: 0.0 },
      referencePattern: {
        patternNumber: 22,
        referencePatternName: 'Scholar',
        singularName: null,
        pluralName: null,
        description: 'A Scholar is accurate, reserved, imaginative and seeks a high level of technical expertise.',
        descriptionBolded:
          'A <strong>Scholar</strong> is accurate, reserved, imaginative and seeks a high level of technical expertise.',
        moreInfoLink: null,
      },
      preferredWorkStyles: [
        '<li>Relatively formal, reserved, and skeptical of new people; requires some “proof” to build trust in new people.</li><li>Attention to detail; follows through on tasks to ensure completion in general accordance with quality standards.</li><li>Operationally, as opposed to socially, focused. Thinks about what needs to be done, and how to do it well, and generally follows that execution plan.</li>',
        '<li>A relatively private individual, it takes [fname] some extra time to connect to and trust new people. Serious and reserved.</li><li>With an ability to concentrate on the task at hand, is generally more focused on the technical matters than the social ones. Consistent and thoughtful.</li><li>Works at a relatively steady pace; best working with familiar processes, environments, and co-workers. Not inclined to change.</li>',
        '<li>Patient, stable, and consistent; does things generally systematically and is not inclined to change these systems. Dependable, relatively consistent and works best in familiar environments, with familiar people.</li><li>Tolerant, easy-going, and uncritical in getting along with others. A focused listener.</li><li>Works steadily at an even pace; most productive with fewer interruptions.</li>',
      ],
      personNeedsListContent: [
        {
          needsListContentTitle: 'Let me think it through',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Opportunities to reflect| Room for introspection| Freedom from office politics| Private recognition| Privacy| Time to trust others| Opportunities to work with facts',
        },
        {
          needsListContentTitle: 'Let me drive',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Balance of: Independence and Encouragement | Control of own activities and Reassurance | To be challenged and Harmony',
        },
        {
          needsListContentTitle: 'Give me stability',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Balance of: Long-term affiliation and Variety | Ability to work at a steady pace and Opportunities to work at a faster than average pace | Familiar surroundings and Mobility',
        },
        {
          needsListContentTitle: 'Give me structure',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Balance of: Understanding of rules and regulations and Freedom from rigid structure | Specific knowledge of the job and Freedom of expression | Freedom from risk of error and Opportunities to delegate details',
        },
      ],
      strengths: 'Data-driven, analytical| Strong discipline and execution| Organized and thorough follow-up',
      cautionAreas:
        'May be cautious about acting on new or controversial ideas | Can be anxious to avoid disagreements | Often uncomfortable in new environments or social situations',
      factors: [
        {
          letter: 'A',
          sigmaZone: 0,
          absoluteSigmaValue: 0.15,
          motivatingNeedTraits:
            'Balance of: Independence and Encouragement | Control of own activities and Reassurance | To be challenged and Harmony',
          behaviorTraits:
            'Independent and Cooperative | Assertive and Accepting of company policies | Self-confident and Accommodating',
          sigmaRangeTraits: 'Independent and Unselfish | Competitive and Peaceable | Self-starting and Caring ',
          factorName: 'Dominance',
          primaryTrait: 'Situationally Assertive and Agreeable',
          leftFactorTrait: 'Situationally Collaborative',
          rightFactorTrait: 'Situationally Independent',
        },
        {
          letter: 'B',
          sigmaZone: -1,
          absoluteSigmaValue: 0.45,
          motivatingNeedTraits:
            'Opportunities to reflect| Room for introspection| Freedom from office politics| Private recognition| Privacy| Time to trust others| Opportunities to work with facts',
          behaviorTraits: 'Introspective| Matter-of-fact| Analytical| Imaginative| Reflective| Pensive',
          sigmaRangeTraits: 'Moderately Reserved| Collected| Thoughtful| Reflective',
          factorName: 'Extraversion',
          primaryTrait: 'Reserved',
          leftFactorTrait: 'Moderately Reserved',
          rightFactorTrait: 'Sociable',
        },
        {
          letter: 'C',
          sigmaZone: 0,
          absoluteSigmaValue: 0.15,
          motivatingNeedTraits:
            'Balance of: Long-term affiliation and Variety | Ability to work at a steady pace and Opportunities to work at a faster than average pace | Familiar surroundings and Mobility',
          behaviorTraits: 'Agreeable and Intense | Patient and Restless | Stable and Driving',
          sigmaRangeTraits: 'Relaxed and Tense | Stable and Quick | Calm and Hasty',
          factorName: 'Patience',
          primaryTrait: 'Situationally Steady and Impatient',
          leftFactorTrait: 'Situationally Driving',
          rightFactorTrait: 'Situationally Steady',
        },
        {
          letter: 'D',
          sigmaZone: 0,
          absoluteSigmaValue: 0.15,
          motivatingNeedTraits:
            'Balance of: Understanding of rules and regulations and Freedom from rigid structure | Specific knowledge of the job and Freedom of expression | Freedom from risk of error and Opportunities to delegate details',
          behaviorTraits: 'Serious and Informal | Diligent and Tolerant of uncertainty | Reserved and Flexible',
          sigmaRangeTraits: 'Conservative and Casual | Thorough and Uninhibited | Respectful and Easy',
          factorName: 'Formality',
          primaryTrait: 'Situationally Conforming and Non-Conforming',
          leftFactorTrait: 'Situationally Flexible',
          rightFactorTrait: 'Situationally Precise',
        },
      ],
      factorDescriptions: [
        {
          factorLetter: 'A',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'If someone is very close to the center (midpoint), the expression of this drive may depend on the specific context or situation.',
        },
        {
          factorLetter: 'B',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They’re introspective and prefer to have time to think before responding. They take an analytical and matter-of-fact approach to shared decisions. They are thoughtful and sincere in their communications.',
        },
        {
          factorLetter: 'C',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'If someone is very close to the center (midpoint), the expression of this drive may depend on the specific context or situation.',
        },
        {
          factorLetter: 'D',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'If someone is very close to the center (midpoint), the expression of this drive may depend on the specific context or situation.',
        },
        {
          factorLetter: 'E',
          factorDescription:
            'Shifts between objectivity and subjectivity; may favor facts or intuition based on the situation',
          factorFullDescription:
            'If someone is very close to the center (midpoint), the expression of this drive may depend on the specific context or situation.',
        },
      ],
      factorCombinations: [
        {
          traits: 'Analytical| Cautious | Practical | Solves problems using detailed information',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A over B',
          primaryTrait: 'Task-oriented',
          isAdapterPattern: null,
        },
        {
          traits: 'Situationally proactive or responsive',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A equal C',
          primaryTrait: 'Proactive or responsive',
          isAdapterPattern: null,
        },
        {
          traits:
            'Moderate drives to both control the decision and do it right | May experience tension when making decisions',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A equal D',
          primaryTrait: 'Comfortable or cautious with risk',
          isAdapterPattern: null,
        },
        {
          traits: 'Task-oriented | Thoughtful | Reserved | Serious | Private',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'C over B',
          primaryTrait: 'Takes time to connect',
          isAdapterPattern: null,
        },
        {
          traits: 'Reserved | Private | Straight forward communicator',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'D over B',
          primaryTrait: 'Formal',
          isAdapterPattern: null,
        },
        {
          traits: 'Situationally casual or careful with rules',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'C equal D',
          primaryTrait: 'Casual or careful with rules',
          isAdapterPattern: null,
        },
      ],
      hasPendingBa: false,
      assessmentUserId: '4455d4ec-e8ea-47e8-8437-f42b36c7f7ae',
    },
    {
      name: { first: 'Aliza', last: 'Ballard', middle: null, goesBy: null, prefix: null, suffix: null },
      selfAssessmentScore: { aSigma: 0.74, bSigma: 1.2, cSigma: -1.17, dSigma: -0.78, eSigma: 0.88 },
      referencePattern: {
        patternNumber: 36,
        referencePatternName: 'Persuader',
        singularName: null,
        pluralName: null,
        description: 'A Persuader is a risk-taking, socially poised and motivating team builder.',
        descriptionBolded:
          'A \u003cstrong\u003ePersuader\u003c/strong\u003e is a risk-taking, socially poised and motivating team builder.',
        moreInfoLink: null,
      },
      preferredWorkStyles: [
        '\u003cli\u003eProactively connects quickly to others; open and sharing. Builds and leverages relationships to get work done.\u003c/li\u003e\u003cli\u003eComfortably fluent and fast talk, in volume. Enthusiastically persuades and motivates others by considering their point of view and adjusting delivery.\u003c/li\u003e\u003cli\u003eCollaborative; usually works with and through others. Intuitive understanding of team cohesion, dynamics, and interpersonal relations.\u003c/li\u003e',
        '\u003cli\u003eSocially informal, extroverted, and outgoing; gets familiar quickly. Communicates in an uninhibited, lively, and adaptable manner, drawing others into the conversation.\u003c/li\u003e\u003cli\u003eInterested in people, building relationships, and teamwork rather than technical matters. Affable, optimistic, and easily trusting.\u003c/li\u003e\u003cli\u003eFocused on goals and the people needed to get there, not details or plans; frequently delegates details.\u003c/li\u003e',
        '\u003cli\u003eProactivity, assertiveness, and sense of urgency in driving to reach personal goals. Openly challenges the world.\u003c/li\u003e\u003cli\u003eIndependent in putting forth their own ideas, which are often innovative and, if implemented, cause change. Resourcefully works through or around anything blocking completion of what they want to accomplish; aggressive when challenged.\u003c/li\u003e\u003cli\u003eImpatient for results, puts pressure on themself and others for rapid implementation, and is far less productive when doing routine work.\u003c/li\u003e',
      ],
      personNeedsListContent: [
        {
          needsListContentTitle: 'Let me talk it out',
          patternInsightsNeedsContent: 'Needs lots of...',
          needsListContent:
            'Opportunities to interact| Social acceptance| Opportunities to influence| Public recognition| Connection with others| Visible signs of accomplishments| Opportunities to work with others',
        },
        {
          needsListContentTitle: 'Give me variety',
          patternInsightsNeedsContent: 'Needs lots of...',
          needsListContent:
            'Variety| Opportunities to work at a faster than average pace| Mobility| Freedom from repetition| Opportunities to handle multiple priorities| Freedom from routine| Change',
        },
        {
          needsListContentTitle: 'Give me flexibility',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Freedom from rigid structure| Freedom of expression| Opportunities to delegate details| Freedom from rules and controls| Flexibility| Informality| Opportunities to be spontaneous',
        },
        {
          needsListContentTitle: 'Let me drive',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Independence| Control of own activities| To be challenged| Understanding of the big picture| Autonomy in problem solving| Individual recognition| Opportunities to compete',
        },
      ],
      strengths:
        'Drives change and challenges status quo| Motivating, stimulating communicator| Proactive and results-oriented',
      cautionAreas:
        'May appear talkative or superficial | May provide limited follow up or attention to detail | May appear too casual or uninhibited',
      factors: [
        {
          letter: 'A',
          sigmaZone: 1,
          absoluteSigmaValue: 0.74,
          motivatingNeedTraits:
            'Independence| Control of own activities| To be challenged| Understanding of the big picture| Autonomy in problem solving| Individual recognition| Opportunities to compete',
          behaviorTraits:
            'Independent| Assertive| Self-confident| Venturesome| Competitive| Comfortable with conflict| Autonomous ',
          sigmaRangeTraits: 'Moderately Assertive| Independent| Determined| Autonomous',
          factorName: 'Dominance',
          primaryTrait: 'Assertive',
          leftFactorTrait: 'Collaborative',
          rightFactorTrait: 'Moderately Independent',
        },
        {
          letter: 'B',
          sigmaZone: 1,
          absoluteSigmaValue: 1.2,
          motivatingNeedTraits:
            'Opportunities to interact| Social acceptance| Opportunities to influence| Public recognition| Connection with others| Visible signs of accomplishments| Opportunities to work with others',
          behaviorTraits: 'Outgoing| People oriented| Persuasive| Stimulating| Enthusiastic| Empathetic| Sociable',
          sigmaRangeTraits: 'Moderately Outgoing| Sociable| Talkative| Open',
          factorName: 'Extraversion',
          primaryTrait: 'Outgoing',
          leftFactorTrait: 'Reserved',
          rightFactorTrait: 'Moderately Sociable',
        },
        {
          letter: 'C',
          sigmaZone: -1,
          absoluteSigmaValue: 1.17,
          motivatingNeedTraits:
            'Variety| Opportunities to work at a faster than average pace| Mobility| Freedom from repetition| Opportunities to handle multiple priorities| Freedom from routine| Change',
          behaviorTraits: 'Intense| Restless| Driving| Impatient| Rushed| Fast-paced',
          sigmaRangeTraits: 'Moderately Impatient| Hurried| Brisk| Quick',
          factorName: 'Patience',
          primaryTrait: 'Impatient',
          leftFactorTrait: 'Moderately Driving',
          rightFactorTrait: 'Steady',
        },
        {
          letter: 'D',
          sigmaZone: -1,
          absoluteSigmaValue: 0.78,
          motivatingNeedTraits:
            'Freedom from rigid structure| Freedom of expression| Opportunities to delegate details| Freedom from rules and controls| Flexibility| Informality| Opportunities to be spontaneous',
          behaviorTraits: 'Informal| Tolerant of uncertainty| Flexible| Spontaneous| Non-conforming| Casual| Adaptable',
          sigmaRangeTraits: 'Moderately Flexible| Casual| Uninhibited| Adaptable',
          factorName: 'Formality',
          primaryTrait: 'Non-conforming',
          leftFactorTrait: 'Moderately Flexible',
          rightFactorTrait: 'Precise',
        },
      ],
      factorDescriptions: [
        {
          factorLetter: 'A',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            "They have many ideas and opinions and they're keen to share them. They're hands-on and focused on producing results. They value independence and autonomy.",
        },
        {
          factorLetter: 'B',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            "This person is energized by interacting with others. They're approachable, friendly, and pleasant around others. you can count on them to share and build enthusiasm—a consummate team-first person.",
        },
        {
          factorLetter: 'C',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They may act with a sense of urgency, wanting to get tasks done. They benefit from variety in their workload and can quickly take the reins of a project if it needs to be pushed forward to completion.',
        },
        {
          factorLetter: 'D',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They’ll generally consider the endgame—the ultimate goal or finished product—over the means of execution. They don’t adhere to a given system or process if there is a more efficient approach that still satisfies all parties and objectives.',
        },
        {
          factorLetter: 'E',
          factorDescription: 'Leans toward logic; likely to weigh facts and data over opinions',
          factorFullDescription:
            "They are guided by logic. When making a decision, they're likely to weigh facts and data over opinions. They tend to be contemplative and analytical in their day-to-day work.",
        },
      ],
      factorCombinations: [
        {
          traits:
            'Social orientation | Enthusiastic | Persuasive | Assertive | Determined |Goal-oriented | Delegates authority | Demands results | Leader',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'B over A',
          primaryTrait: 'People-oriented',
          isAdapterPattern: null,
        },
        {
          traits:
            'Takes initiative| Competitive| Driven to get things done| Positive response to pressure| Fast-paced| Achievement-oriented| Impatient with routine',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A over C',
          primaryTrait: 'Proactive',
          isAdapterPattern: null,
        },
        {
          traits: 'Independent| Individualistic| Self-confident| Firm| Decisive| Venturesome| Resistant to authority',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A over D',
          primaryTrait: 'Comfortable with risk',
          isAdapterPattern: null,
        },
        {
          traits:
            'Fluent| Fast-talking| Lively| Enthusiastic| Optimistic style of expression| Persuasive| Motivates others| Stimulating| Positive communication',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'B over C',
          primaryTrait: 'Quick to connect',
          isAdapterPattern: null,
        },
        {
          traits:
            'Extraverted| Outgoing| Uninhibited expression of friendliness| Poised| Informal in social situations| Enthusiastic, persuasive talker| Engaging conversationalist',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'B over D',
          primaryTrait: 'Informal',
          isAdapterPattern: null,
        },
        {
          traits: 'Situationally casual or careful with rules',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'C equal D',
          primaryTrait: 'Casual or careful with rules',
          isAdapterPattern: null,
        },
      ],
      hasPendingBa: false,
      assessmentUserId: '977ec2cb-ba6a-407b-acc4-1fa454626ecf',
    },
    {
      name: { first: 'Tina', last: 'Blackburn', middle: '', goesBy: '', prefix: null, suffix: null },
      selfAssessmentScore: { aSigma: 0.3, bSigma: 0.0, cSigma: -1.41, dSigma: 1.1, eSigma: 0.13 },
      referencePattern: {
        patternNumber: 14,
        referencePatternName: 'Controller',
        singularName: null,
        pluralName: null,
        description:
          'A Controller is detail-oriented and conservative, with a preference for high quality and technical expertise.',
        descriptionBolded:
          'A \u003cstrong\u003eController\u003c/strong\u003e is detail-oriented and conservative, with a preference for high quality and technical expertise.',
        moreInfoLink: null,
      },
      preferredWorkStyles: [
        '\u003cli\u003eCareful with rules; precise, "by the book", fast-paced, and literal in interpreting rules, schedules and results.\u003c/li\u003e\u003cli\u003eDetail-oriented and thorough; works to ensure things don’t fall through the cracks, and follows up to ensure they’re done properly and on time.\u003c/li\u003e\u003cli\u003eDriven to achieve operational efficiencies: thinks about what needs to be done and how it can be done as fast as possible while maintaining a high-quality outcome. Impatient with routines.\u003c/li\u003e',
        '\u003cli\u003eProactivity, assertiveness, and sense of urgency in driving to reach personal goals. Openly challenges the world.\u003c/li\u003e\u003cli\u003eIndependent in putting forth their own ideas, which are often innovative and, if implemented, cause change. Resourcefully works through or around anything blocking completion of what they want to accomplish; aggressive when challenged.\u003c/li\u003e\u003cli\u003eImpatient for results, puts pressure on themself and others for rapid implementation, and is far less productive when doing routine work.\u003c/li\u003e',
        '\u003cli\u003eFormal, reserved, introspective, and skeptical of new people; requires “proof” to build trust in new people.\u003c/li\u003e\u003cli\u003eDetail-oriented and precise; follow-through is deep and literal to ensure tasks were completed in accordance with quality standards.\u003c/li\u003e\u003cli\u003eOperationally, as opposed to socially, focused. Thinks, in specific terms, about what needs to be done and how to do it accurately and flawlessly; follows, in a literal way, that execution plan.\u003c/li\u003e',
      ],
      personNeedsListContent: [
        {
          needsListContentTitle: 'Give me variety',
          patternInsightsNeedsContent: 'Needs lots of...',
          needsListContent:
            'Variety| Opportunities to work at a faster than average pace| Mobility| Freedom from repetition| Opportunities to handle multiple priorities| Freedom from routine| Change',
        },
        {
          needsListContentTitle: 'Give me structure',
          patternInsightsNeedsContent: 'Needs lots of...',
          needsListContent:
            'Understanding of rules and regulations| Specific knowledge of the job| Freedom from risk of error| Time to gain expertise| Recognition for depth of knowledge| Clarity of expectations| Certainty',
        },
        {
          needsListContentTitle: 'Let me drive',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Independence| Control of own activities| To be challenged| Understanding of the big picture| Autonomy in problem solving| Individual recognition| Opportunities to compete',
        },
        {
          needsListContentTitle: 'Let me talk it out',
          patternInsightsNeedsContent: 'Needs some...',
          needsListContent:
            'Balance of: Opportunities to interact and Opportunities to reflect | Social acceptance and Room for introspection | Opportunities to influence and Freedom from office politics',
        },
      ],
      strengths: 'Builds structure and has respect for the plan| Anticipates problems| Proactive and results-oriented',
      cautionAreas:
        'Can have difficulty delegating authority | Resistant to change if it feels too brusque | Likely to feel uncomfortable in ambiguous situations\n',
      factors: [
        {
          letter: 'A',
          sigmaZone: 1,
          absoluteSigmaValue: 0.3,
          motivatingNeedTraits:
            'Independence| Control of own activities| To be challenged| Understanding of the big picture| Autonomy in problem solving| Individual recognition| Opportunities to compete',
          behaviorTraits:
            'Independent| Assertive| Self-confident| Venturesome| Competitive| Comfortable with conflict| Autonomous ',
          sigmaRangeTraits: 'Moderately Assertive| Independent| Determined| Autonomous',
          factorName: 'Dominance',
          primaryTrait: 'Assertive',
          leftFactorTrait: 'Collaborative',
          rightFactorTrait: 'Moderately Independent',
        },
        {
          letter: 'B',
          sigmaZone: 0,
          absoluteSigmaValue: 0.0,
          motivatingNeedTraits:
            'Balance of: Opportunities to interact and Opportunities to reflect | Social acceptance and Room for introspection | Opportunities to influence and Freedom from office politics',
          behaviorTraits: 'Outgoing and Introspective | People oriented and Matter-of-fact | Persuasive and Analytical',
          sigmaRangeTraits: 'Sociable and Quiet | Persuasive and Sincere | Talkative and Introspective',
          factorName: 'Extraversion',
          primaryTrait: 'Situationally Outgoing and Reserved',
          leftFactorTrait: 'Situationally Reserved',
          rightFactorTrait: 'Situationally Sociable',
        },
        {
          letter: 'C',
          sigmaZone: -2,
          absoluteSigmaValue: 1.41,
          motivatingNeedTraits:
            'Variety| Opportunities to work at a faster than average pace| Mobility| Freedom from repetition| Opportunities to handle multiple priorities| Freedom from routine| Change',
          behaviorTraits: 'Intense| Restless| Driving| Impatient| Rushed| Fast-paced',
          sigmaRangeTraits: 'Very Impatient| Restless| Abrupt| Rapid',
          factorName: 'Patience',
          primaryTrait: 'Impatient',
          leftFactorTrait: 'Very Driving',
          rightFactorTrait: 'Steady',
        },
        {
          letter: 'D',
          sigmaZone: 1,
          absoluteSigmaValue: 1.1,
          motivatingNeedTraits:
            'Understanding of rules and regulations| Specific knowledge of the job| Freedom from risk of error| Time to gain expertise| Recognition for depth of knowledge| Clarity of expectations| Certainty',
          behaviorTraits: 'Serious| Diligent| Reserved| Thorough| Precise| Organized| Cautious',
          sigmaRangeTraits: 'Moderately Careful| Conservative| Thorough| Serious',
          factorName: 'Formality',
          primaryTrait: 'Conforming',
          leftFactorTrait: 'Flexible',
          rightFactorTrait: 'Moderately Precise',
        },
      ],
      factorDescriptions: [
        {
          factorLetter: 'A',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            "They have many ideas and opinions and they're keen to share them. They're hands-on and focused on producing results. They value independence and autonomy.",
        },
        {
          factorLetter: 'B',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'If someone is very close to the center (midpoint), the expression of this drive may depend on the specific context or situation.',
        },
        {
          factorLetter: 'C',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They are eager to take action and become restless if they don’t see results or production. They prefer things to be dynamic and fluid rather than stagnant or predictable and they may prefer that their team work on multiple priorities at once.',
        },
        {
          factorLetter: 'D',
          factorDescription: 'Key Not Found in default[en-us] ',
          factorFullDescription:
            'They’re relatively cautious and may hesitate to adopt a new approach to their work without explicit approval. They thrive on clarity, and can develop guidelines that enable others to perform high-quality work within the confines of established processes or systems.',
        },
        {
          factorLetter: 'E',
          factorDescription:
            'Shifts between objectivity and subjectivity; may favor facts or intuition based on the situation',
          factorFullDescription:
            'If someone is very close to the center (midpoint), the expression of this drive may depend on the specific context or situation.',
        },
      ],
      factorCombinations: [
        {
          traits: 'Situationally task- or people-oriented',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A equal B',
          primaryTrait: 'Task- or people-oriented',
          isAdapterPattern: null,
        },
        {
          traits:
            'Takes initiative| Competitive| Driven to get things done| Positive response to pressure| Fast-paced| Achievement-oriented| Impatient with routine',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'A over C',
          primaryTrait: 'Proactive',
          isAdapterPattern: null,
        },
        {
          traits: 'Rule follower | Thorough | Accurate | Seeks independence and autonomy in area of expertise',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'D over A',
          primaryTrait: 'Cautious with risk',
          isAdapterPattern: null,
        },
        {
          traits: 'Sense of urgency | Task-oriented | Impatient with routines | Takes time to build relationships\n',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'B over C',
          primaryTrait: 'Quick to connect',
          isAdapterPattern: null,
        },
        {
          traits: 'Formal | Social | Proper | Trouble delegating details| Detailed and talkative communicator',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'D over B',
          primaryTrait: 'Formal',
          isAdapterPattern: null,
        },
        {
          traits:
            'Conscientious| Thorough| Precise| Concerned with rules and accuracy| Strong follow-up| Strict about punctuality and correctness| Comfortable with clarity',
          type: 'Unknown',
          midpointRelationship: 'Unknown',
          factorDistance: 0,
          factorDifference: 0,
          typeDescription: 'D over C',
          primaryTrait: 'Careful with rules',
          isAdapterPattern: null,
        },
      ],
      hasPendingBa: false,
      assessmentUserId: '65d3b1ef-c53e-4724-8015-7ea17d3ddc94',
    },
  ];

  const dataWithNameMatch = data.find(d => d.name.first === firstName);
  if (dataWithNameMatch) {
    return dataWithNameMatch;
  } else {
    return data[0];
  }
}

export function getRelationshipData(person1, person2, firstName) {
  const data = [
    {
      person1: '4295f848-039a-4086-9f88-9256f05ebac7',
      person2: '4455d4ec-e8ea-47e8-8437-f42b36c7f7ae',
      person1DisplayName: 'Lisa',
      person2DisplayName: 'Chaya',
      relationshipGuideDetails: [
        {
          person1Name: 'Lin',
          person2Name: 'Lisa',
          relationshipId: '253276d4-d282-4a2e-8cd0-6c459266dc24',
          relationshipType: 'communication',
          factor: 'A',
          factorComparison: 'GreaterThan',
          relationshipStrengthsKey:
            "Chaya can help Lisa by supporting their ideas and creating a unified front when communicating Lisa's perspective to other stakeholders.",
          relationshipCautionsKey: "Chaya may dominate the agenda, and Lisa's ideas or concerns may get overlooked.",
          relationshipTipsKey:
            'Chaya may be the one who tends to set the agenda, but Chaya should make sure to let Lisa have their say, pausing to ask Lisa for reactions or feedback, as well as giving credit and acknowledging when Lisa has a great idea or suggestion.',
        },
        {
          person1Name: 'Chaya',
          person2Name: 'Lisa',
          relationshipId: 'cfe7c2d6-d7a1-49bc-850d-0bbf8c323ef8',
          relationshipType: 'communication',
          factor: 'B',
          factorComparison: 'GreaterThan',
          relationshipStrengthsKey:
            'Chaya is eager to start conversations and will typically be the communication initiator with Lisa.',
          relationshipCautionsKey:
            "Lisa may be overwhelmed by Chaya's eagerness to have a conversation, and Lisa may politely seek to shorten or avoid interactions with Chaya.",
          relationshipTipsKey:
            'Chaya should set up a time to speak with Lisa rather than dropping by and asking Lisa questions spur of the moment, but Lisa should also make the effort to ask Chaya for feedback or opinions.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Chaya',
          relationshipId: '13a77e14-34a9-4dca-b173-750a0a6c08b1',
          relationshipType: 'communication',
          factor: 'C',
          factorComparison: 'BothLow',
          relationshipStrengthsKey:
            'Lisa and Chaya take a transactive approach to communication, quickly getting to the point, and moving on to the next topic.',
          relationshipCautionsKey:
            'Lisa and Chaya may have difficulty moving a conversation forward constructively when they do not agree with each other or when they are both indecisive.',
          relationshipTipsKey:
            'Lisa and Chaya should be sure not to talk past each other, and they should try to self-regulate to make sure the other person understands what they are trying to say.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Chaya',
          relationshipId: '0c04b2bf-7bd1-4db0-8a7d-d10889cd810e',
          relationshipType: 'communication',
          factor: 'D',
          factorComparison: 'GreaterThan',
          relationshipStrengthsKey:
            "Chaya can discuss broad ideas, but Lisa is good at translating Chaya's suggestions into specifics.",
          relationshipCautionsKey:
            'Lisa may feel like Chaya communicates without getting to the point, whereas Chaya may feel like Lisa is too focused on the details.',
          relationshipTipsKey:
            'Lisa should make sure that Chaya is clear on specific action items and next steps when they end conversations.',
        },
      ],
    },
    {
      person1: '4295f848-039a-4086-9f88-9256f05ebac7',
      person2: '65d3b1ef-c53e-4724-8015-7ea17d3ddc94',
      person1DisplayName: 'Lisa',
      person2DisplayName: 'Tina',
      relationshipGuideDetails: [
        {
          person1Name: 'Tina',
          person2Name: 'Lisa',
          relationshipId: '253276d4-d282-4a2e-8cd0-6c459266dc24',
          relationshipType: 'communication',
          factor: 'A',
          factorComparison: 'GreaterThan',
          relationshipStrengthsKey:
            "Tina can help Lisa by supporting their ideas and creating a unified front when communicating Lisa's perspective to other stakeholders.",
          relationshipCautionsKey: "Tina may dominate the agenda, and Lisa's ideas or concerns may get overlooked.",
          relationshipTipsKey:
            'Tina may be the one who tends to set the agenda, but Tina should make sure to let Lisa have their say, pausing to ask Lisa for reactions or feedback, as well as giving credit and acknowledging when Lisa has a great idea or suggestion.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Tina',
          relationshipId: '818e302a-525f-46e9-82ff-caa086da9fb6',
          relationshipType: 'communication',
          factor: 'B',
          factorComparison: 'BothLow',
          relationshipStrengthsKey: 'Lisa and Tina communicate efficiently and quickly get to the point.',
          relationshipCautionsKey:
            'Lisa and Tina may be reserved and hesitant to begin a conversation on their own initiative.',
          relationshipTipsKey:
            'Lisa and Tina should remember to periodically check that they are learning from each other and evaluate whether they have access to information that might benefit the other person.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Tina',
          relationshipId: '13a77e14-34a9-4dca-b173-750a0a6c08b1',
          relationshipType: 'communication',
          factor: 'C',
          factorComparison: 'BothLow',
          relationshipStrengthsKey:
            'Lisa and Tina take a transactive approach to communication, quickly getting to the point, and moving on to the next topic.',
          relationshipCautionsKey:
            'Lisa and Tina may have difficulty moving a conversation forward constructively when they do not agree with each other or when they are both indecisive.',
          relationshipTipsKey:
            'Lisa and Tina should be sure not to talk past each other, and they should try to self-regulate to make sure the other person understands what they are trying to say.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Tina',
          relationshipId: '927e9e8e-0db8-4216-b159-1ac9ff959670',
          relationshipType: 'communication',
          factor: 'D',
          factorComparison: 'BothHigh',
          relationshipStrengthsKey:
            'Lisa and Tina communicate primarily in a detailed and transactional manner at work, exchanging information to keep work moving forward.',
          relationshipCautionsKey:
            'Communication between Lisa and Tina  may falter if they become too focused on their individual work.',
          relationshipTipsKey:
            "Lisa and Tina should also take care to respect each other's areas of control and expertise.",
        },
      ],
    },
    {
      person1: '4295f848-039a-4086-9f88-9256f05ebac7',
      person2: '977ec2cb-ba6a-407b-acc4-1fa454626ecf',
      person1DisplayName: 'Lisa',
      person2DisplayName: 'Aliza',
      relationshipGuideDetails: [
        {
          person1Name: 'Lisa',
          person2Name: 'Aliza',
          relationshipId: '6680c2c3-0002-4873-88d7-1511d910cb09',
          relationshipType: 'communication',
          factor: 'A',
          factorComparison: 'BothLow',
          relationshipStrengthsKey: 'Lisa and Aliza are friendly, collaborative and agreeable in communication.',
          relationshipCautionsKey: 'Lisa and Aliza may have trouble turning discussions into action.',
          relationshipTipsKey:
            'Lisa and Aliza should be forthcoming with each other if one of them feels that communication could be improved, such as a change in the mode or format of the communication.',
        },
        {
          person1Name: 'Aliza',
          person2Name: 'Lisa',
          relationshipId: 'cfe7c2d6-d7a1-49bc-850d-0bbf8c323ef8',
          relationshipType: 'communication',
          factor: 'B',
          factorComparison: 'GreaterThan',
          relationshipStrengthsKey:
            'Aliza is eager to start conversations and will typically be the communication initiator with Lisa.',
          relationshipCautionsKey:
            "Lisa may be overwhelmed by Aliza's eagerness to have a conversation, and Lisa may politely seek to shorten or avoid interactions with Aliza.",
          relationshipTipsKey:
            'Aliza should set up a time to speak with Lisa rather than dropping by and asking Lisa questions spur of the moment, but Lisa should also make the effort to ask Aliza for feedback or opinions.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Aliza',
          relationshipId: '13a77e14-34a9-4dca-b173-750a0a6c08b1',
          relationshipType: 'communication',
          factor: 'C',
          factorComparison: 'BothLow',
          relationshipStrengthsKey:
            'Lisa and Aliza take a transactive approach to communication, quickly getting to the point, and moving on to the next topic.',
          relationshipCautionsKey:
            'Lisa and Aliza may have difficulty moving a conversation forward constructively when they do not agree with each other or when they are both indecisive.',
          relationshipTipsKey:
            'Lisa and Aliza should be sure not to talk past each other, and they should try to self-regulate to make sure the other person understands what they are trying to say.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Aliza',
          relationshipId: '0c04b2bf-7bd1-4db0-8a7d-d10889cd810e',
          relationshipType: 'communication',
          factor: 'D',
          factorComparison: 'GreaterThan',
          relationshipStrengthsKey:
            "Aliza can discuss broad ideas, but Lisa is good at translating Aliza's suggestions into specifics.",
          relationshipCautionsKey:
            'Lisa may feel like Aliza communicates without getting to the point, whereas Aliza may feel like Lisa is too focused on the details.',
          relationshipTipsKey:
            'Lisa should make sure that Aliza is clear on specific action items and next steps when they end conversations.',
        },
      ],
    },
    {
      person1: '4295f848-039a-4086-9f88-9256f05ebac7',
      person2: '89d0b543-5486-4d1c-9012-ac306bc26c40',
      person1DisplayName: 'Lisa',
      person2DisplayName: 'Will',
      relationshipGuideDetails: [
        {
          person1Name: 'Lisa',
          person2Name: 'Will',
          relationshipId: '6680c2c3-0002-4873-88d7-1511d910cb09',
          relationshipType: 'communication',
          factor: 'A',
          factorComparison: 'BothLow',
          relationshipStrengthsKey: 'Lisa and Will are friendly, collaborative and agreeable in communication.',
          relationshipCautionsKey: 'Lisa and Will may have trouble turning discussions into action.',
          relationshipTipsKey:
            'Lisa and Will should be forthcoming with each other if one of them feels that communication could be improved, such as a change in the mode or format of the communication.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Will',
          relationshipId: '818e302a-525f-46e9-82ff-caa086da9fb6',
          relationshipType: 'communication',
          factor: 'B',
          factorComparison: 'BothLow',
          relationshipStrengthsKey: 'Lisa and Will communicate efficiently and quickly get to the point.',
          relationshipCautionsKey:
            'Lisa and Will may be reserved and hesitant to begin a conversation on their own initiative.',
          relationshipTipsKey:
            'Lisa and Will should remember to periodically check that they are learning from each other and evaluate whether they have access to information that might benefit the other person.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Will',
          relationshipId: '13a77e14-34a9-4dca-b173-750a0a6c08b1',
          relationshipType: 'communication',
          factor: 'C',
          factorComparison: 'BothLow',
          relationshipStrengthsKey:
            'Lisa and Will take a transactive approach to communication, quickly getting to the point, and moving on to the next topic.',
          relationshipCautionsKey:
            'Lisa and Will may have difficulty moving a conversation forward constructively when they do not agree with each other or when they are both indecisive.',
          relationshipTipsKey:
            'Lisa and Will should be sure not to talk past each other, and they should try to self-regulate to make sure the other person understands what they are trying to say.',
        },
        {
          person1Name: 'Lisa',
          person2Name: 'Will',
          relationshipId: '927e9e8e-0db8-4216-b159-1ac9ff959670',
          relationshipType: 'communication',
          factor: 'D',
          factorComparison: 'BothHigh',
          relationshipStrengthsKey:
            'Lisa and Will communicate primarily in a detailed and transactional manner at work, exchanging information to keep work moving forward.',
          relationshipCautionsKey:
            'Communication between Lisa and Will  may falter if they become too focused on their individual work.',
          relationshipTipsKey:
            "Lisa and Will should also take care to respect each other's areas of control and expertise.",
        },
      ],
    },
  ];

  const dataWithMatch = data.find(d => d.person1 === person1 && d.person2 === person2);
  let result = JSON.stringify(dataWithMatch);
  let sanitized = result.replace(/Lisa/g, firstName);
  return JSON.parse(sanitized);
}

export function getTeamInfoDemoData() {
  return {
    teamType: 'Producing',
    shortTeamDescription: 'Competitive  |  Intense  |  Task-oriented',
    teamConversationTips:
      '<li>Set high performance standards and hold one another accountable</li><li>Identify ambitious challenges and set action items to execute</li><li>Make win-win decisions that benefit each individual team member</li>',
    teamReminders:
      '<li>When the team wins, you win; know when to prioritize collective goals</li><li>Ease up on competition when it starts to detract from performance</li><li>Take regular pauses from producing to celebrate your successes</li>',
    individualContributionInsight: [
      { contributionInsight: 'Drives change and execution', userGuid: '0fa153a3-c993-4191-b31e-e0855b7cfdce' }, // Lisa Hendrix
      { contributionInsight: 'Drives change and execution', userGuid: '1fa153a3-c993-4191-b31e-e0855b7cfdce' }, //Aliza Ballard
      {
        contributionInsight: 'Keeps the team organized and on-track',
        userGuid: '2fa153a3-c993-4191-b31e-e0855b7cfdce',
      }, // Tina Blackburn
      {
        contributionInsight: 'Keeps the team organized and on-track',
        userGuid: '3fa153a3-c993-4191-b31e-e0855b7cfdce',
      }, // Chaya Long
      {
        contributionInsight: 'Provides detail orientation and accuracy',
        userGuid: '4fa153a3-c993-4191-b31e-e0855b7cfdce',
      }, // Will Marks
    ],
    individualPrivateSelfReminders: [
        "Gain alignment on a shared goal before proposing solutions",
        "Challenge your existing notions by asking others what they think",
        "Don't let perfection get in the way of completing a project"
    ]
  };
}

export function getPiUserGuidByName(name) {
  const nameGuidDictionary = {
    'Lisa Hendrix': '0fa153a3-c993-4191-b31e-e0855b7cfdce',
    'Aliza Ballard': '1fa153a3-c993-4191-b31e-e0855b7cfdce',
    'Tina Blackburn': '2fa153a3-c993-4191-b31e-e0855b7cfdce',
    'Chaya Long': '3fa153a3-c993-4191-b31e-e0855b7cfdce',
    'Will Marks': '4fa153a3-c993-4191-b31e-e0855b7cfdce',
  };
  return nameGuidDictionary[name] || null;
}
